<template>
	<div style="margin-top:1em">
        <h3 style="text-align:center">{{ 'Rapport de la session du ' + (session.startAt ? formatDate(session.startAt) : '-') + ' au ' + (session.endAt ? formatDate(session.endAt) : '-')}}</h3>
        <div class="form-group" style="margin-top:2em">
            <label>En-tête du document :</label>
            <textarea class="form-control" type="text" v-model="report.header"></textarea>
        </div>
        <div class="form-group">
            <label>Nombre de médecins ayant participé à la totalité du programme (à qui une attestation de DPC a été délivrée) :</label>
            <input id="participantsCount" class="form-control" type="number" v-model="report.nbDoctors"/>
        </div>
        <div class="form-group">
            <label>Les critères étudiés étaient (perspectives d'amélioration indentifiées lors de la mise en place du programme) :</label>
            <quill-editor id="explainationTurn1" v-model.lazy="report.criteriasStudied" @ready=""></quill-editor>
        </div>

        <div class="form-group">
            <label>Critères :</label>
                <div v-for="(criteria, index) in report.criterias" :key="criteria.name" class="row form-group">
                    <div class="col-md-2">
                        <span>{{ criteria.name + ' : ' }}</span>
                    </div>
                    <div class="col-md-10">
                        <span v-html="criteria.text"></span>
                    </div>
                </div>
        </div>
        <div class="form-group">
            <label>Commentaires résultats grille d'audit critique :</label>
            <textarea class="form-control" type="text" v-model="report.resultsComments"></textarea>
        </div>
        <div class="form-group">
            <label>D’autres objectifs d’amélioration ont-ils été identifiés pendant le programme ?</label>
            <div class="form-group">
                <label class="radio-inline">
                    <input type="radio" @click="report.hasGoalImprovements = true" :checked="report.hasGoalImprovements"> Oui
                </label>
                <label class="radio-inline">
                    <input type="radio" @click="report.hasGoalImprovements = false" :checked="!report.hasGoalImprovements"> Non
                </label>
            </div>
        </div>
        <div class="form-group">
            <label>Si OUI, lesquels ?</label>
            <textarea class="form-control" type="text" v-model="report.goalImprovements"></textarea>
        </div>
        <div class="form-group">
            <label>L'analyse des données de pratiques recueillies par les participants a-t-elle permis de constater ou de mesurer des amélioration de pratique entre le début et la fin du programme ?</label>
            <div class="form-group">
                <label class="radio-inline">
                    <input type="radio" value="true" @click="report.hasImprovements = true" :checked="report.hasImprovements"> Oui
                </label>
                <label class="radio-inline">
                    <input type="radio" value="false" @click="report.hasImprovements = false" :checked="!report.hasImprovements"> Non
                </label>
            </div>
        </div>
        <div class="form-group">
            <label>Quelles ont été les actions d'améliorations retenues par les participants à l'issue de la restitution des données ?</label>
            <textarea class="form-control" type="text" v-model="report.improvements"></textarea>
        </div>
        <div class="form-group">
            <label>Envisagez-vous de poursuivre le programme de DPC au sein d'un processus continu :</label>
        </div>
        <div class="form-group form-inline">
            <div class="col-md-3">- avec les mêmes médecins :</div>
            <div class="col-md-9">
                <label class="radio-inline">
                    <input type="radio" value="true" @click="report.pursuitWithSameDoctors = true" :checked="report.pursuitWithSameDoctors"> Oui
                </label>
                <label class="radio-inline">
                    <input type="radio" value="false" @click="report.pursuitWithSameDoctors = false" :checked="!report.pursuitWithSameDoctors"> Non
                </label>
            </div>
        </div>
        <div class="form-group form-inline">
            <div class="col-md-3">- avec d'autres médecins :</div>
            <div class="col-md-9">
                <label class="radio-inline">
                    <input type="radio" value="true" @click="report.pursuitWithOtherDoctors = true" :checked="report.pursuitWithOtherDoctors"> Oui
                </label>
                <label class="radio-inline">
                    <input type="radio" value="false" @click="report.pursuitWithOtherDoctors = false" :checked="!report.pursuitWithOtherDoctors"> Non
                </label>
            </div>
        </div>
        <div class="form-group">
            <label>Commentaires :</label>
            <textarea class="form-control" type="text" v-model="report.comments"></textarea>
        </div>
	</div>
</template>

<script>
    import { quillEditor  as QuillEditor } from 'vue-quill-editor'

    export default {
        components: {
            QuillEditor
        },
        computed: {
            session: function()   {
            return this.$store.state.admin.sessionDetail.detail;
            },
            exportPdfUrl: function()    {
                return '';
            }
        },
        methods: {
            saveReport()    {
                let successCallback = (id) => {
                    this.$router.back();
                    let alertText = "Le modèle par défaut a été mis à jour avec succès.";
                    this.$store.commit('ALERT_DATA_UPDATED', {
                        text: alertText,
                        type: 'success'
                    });
                };

                this.$store.dispatch('updateParentTargetInstance', {
                    parentTargetInstanceId: this.$route.params.sessionId,
                    newParentTargetInstance: {report: this.report},
                    callbacks: { success: successCallback }
                });
            },
            formatDate(date)  {
                let d = new Date(date);
                return d.getDate().toString().padStart(2, "0") + '/' + (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getFullYear() + ' - ' + d.getHours() + ':' + d.getMinutes().toString().padStart(2, "0");
            }
        },
        data: function()  {
            return {
                report: {
                    header: '',
                    nbDoctors: 0,
                    criteriasStudied: '',
                    criterias: [],
                    resultsComments: '',
                    hasGoalImprovements: false,
                    goalImprovements: '',
                    hasImprovements: false,
                    improvements: '',
                    pursuitWithSameDoctors: false,
                    pursuitWithOtherDoctors: false,
                    comments: ''
                }
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                backText: "Retour aux sessions",
                pathData: {
                    name: "TemplateSessions",
                    params: {
                        templateId: this.$route.params.templateId
                    }
                },
                buttonData: [{
                    text: "Sauvegarder",
                    actionToCall: null
                }]
            });
        },
        created()   {
            let report = this.$store.state.admin.sessionDetail.detail.report;
            if (report && report != [])   {
                this.report = report;
            }
        },
        mounted()  {
            this.$emit('navbarUpdate', {
                backText: "Retour aux sessions",
                pathData: {
                    name: "TemplateSessions",
                    params: {
                        templateId: this.$route.params.templateId
                    }
                },
                buttonData: [{
                    text: "Sauvegarder",
                    actionToCall: this.saveReport
                }]
            });
        }
    };
</script>

<style>
</style>